// src/layouts/Pages/PageHeader/CardHeaderColumn/items/nextDueDate.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const nextDueDateItem = (record, contract) => {
  if (!record?._id) return;

  const dueDay = contract?.DUE_DAY;
  const nextDueDate = dueDay ? getNextDueDateFromDay(dueDay) : record?.nextDueDate || getNextDueDate();

  return {
    key: 'nextDueDate',
    icon: <CalendarOutlined />,
    label: dayjs(nextDueDate).format('DD/MM/YYYY'),
    tooltipText: translateX('next_due_date'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export default nextDueDateItem;

// *******************************************************************************
// HELPERS
// *******************************************************************************

// Returns the 5th day of the next month (fallback)
function getNextDueDate() {
  const today = dayjs();
  const nextMonth = today.add(1, 'month');
  return nextMonth.date(5).startOf('day').toDate();
}

// Returns the next due date based on a specific day of month
function getNextDueDateFromDay(day) {
  const today = dayjs();
  const thisMonth = today.date(day).startOf('day');
  // If today is past the due day, next due date is next month
  return today.date() >= day
    ? thisMonth.add(1, 'month').toDate()
    : thisMonth.toDate();
}
